import requestFunctions from "../../functions/requestFunctions";


export const state = {
  FINANCE_ITEM: {},
  FINANCE_LIST: [],
  FINANCE_TABLE_DATA: [],
  FINANCE_TOTAL_ROWS: 0
}

export const getters = {
  GET_FINANCE_ITEM: (state) => {
    return state.FINANCE_ITEM;
  },
  GET_FINANCE_LIST: (state) => {
    return state.FINANCE_LIST;
  },
  GET_FINANCE_TABLE_DATA: (state) => {
    return state.FINANCE_TABLE_DATA;
  },
  GET_FINANCE_TOTAL_ROWS: (state) => {
    return state.FINANCE_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_FINANCE_ITEM(state, item) {
    state.FINANCE_ITEM = item;
  },

  UPDATE_FINANCE_LIST(state, list) {

    state.FINANCE_LIST = list.data;
    state.FINANCE_TABLE_DATA = [];

    state.FINANCE_TOTAL_ROWS = list.total;
    list = list.data;
    
    if(list.length > 0) {
      list.forEach(el => {

        let status;

        if(el.status === 'wait'){
          status = 'Ожидается'
        }
        if(el.status === 'blocked'){
          status = 'Заблокирована'
        }
        if(el.status === 'canceled' || el.status === 'cancel'){
          status = 'Отменена'
        }
        if(el.status === 'success'){
          status = 'Успешно'
        }
        if(el.status === 'processing'){
          status = 'Обработка'
        }
        if(el.status === 'error'){
          status = 'Ошибка'
        }

        let pay_method = '';

        if(el.pay_method === 'invoice'){
          pay_method = 'Счет на оплату'
        }

        if(el.pay_method === 'bankcard'){
          pay_method = 'Банковская карта'
        }

        if(el.pay_method === 'manual'){
          pay_method = 'Ручное пополнение'
        }
        
        let user_data = '';
    
        if(el.profile_fullname !== null){
          user_data = el.profile_fullname;
        }
        
        if(el.user_phone !== null ){
          if(user_data !== ''){
            user_data = user_data + ', ';
          }
          user_data = user_data + el.user_phone;
        }
        
        state.FINANCE_TABLE_DATA.push({
          'id': el.id,
          'created_at': el.created_at,
          'account_number': el.account_number,
          'user_data': user_data,
          'comments': el.comments,
          'sum': el.sum,
          'status': status
        });
      });
    }
  },
}


export const actions = {

  async FETCH_FINANCE_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/finance/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_FINANCE_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_FINANCE_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/finance';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_FINANCE_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_FINANCE_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/finance';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_FINANCE_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/finance/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_FINANCE_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/finance/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}